PageLeaveConfirmationFacade = {
    isInitialized: false,
    /** PageLeaveConfirmationRequestManager */
    manager: null,

    // TODO later
    ///**
    // *
    // * @param options
    // * defaultText
    // *
    // */
    //init: function (options) {
    //    if(this.isInitialized) {
    //        console.log("PageLeaveConfirmationFacade was already initialized.")
    //    }
    //
    //    this.isInitialized = true;
    //    this.manager = new PageLeaveConfirmationRequestManager(options.defaultDialogueUrl);
    //
    //
    //    // TODO register default handler
    //},

    /**
     *
     * @returns {PageLeaveConfirmationRequestManager}
     */
    getManager: function () {
        return this.manager ? this.manager : this.manager = new PageLeaveConfirmationRequestManager();
    },

    /**
     * Registers a checking function that will be called when the user attempts to leave the page.
     *
     * If the checking function returns true, then a browser prompt will be displayed.
     *
     * Options:
     * promptCheckingFunction
     * promptText - the text that should be displayed in the prompt. But for example Mozilla Firefox ignores this text.
     */
    registerPageleaveChecker: function (options) {
        this.getManager().registerPageleaveChecker(options);
    },

    // TODO later
    ///**
    // *
    // * @param options:
    // *
    // * promptCheckingFunction
    // * userLeftCallbackFunction
    // * userStayedCallbackFunction
    // * dialogueUrl - optional - A custom confirmation dialogue retrieval URL.
    // *
    // */
    //registerLinkClickedChecker: function (options) {
    //
    //}

};

function PageLeaveConfirmationRequestManager() {
    /*
     |-------------------------------------------------------------------------
     | Constructor part */
    var PLCRM = this;
    this.pageleaveCheckers = [];

    $(window).on("beforeunload", function () {
        return PLCRM.checkForPageleavePrompts();
    });

    /*
     |-------------------------------------------------------------------------------------------------------------------
     | Methods
     |-------------------------------------------------------------------------------------------------------------------
     */

    this.registerPageleaveChecker = function (options) {
        this.pageleaveCheckers.push(options);
    };

    /**
     * Checks all the functions provided by registered checkers. The text of the first one (and only of the first
     * one!) that returns true will be returned and should be displayed.
     *
     * @returns {undefined}
     */
    this.checkForPageleavePrompts = function () {
        var returnedText = undefined;

        _.any(this.pageleaveCheckers, function (options) {
            var promptCheckingFunction = options.promptCheckingFunction;
            var promptText = options.promptText;

            if(promptCheckingFunction()) {
                returnedText = promptText;
                return true;
            }
        });

        return returnedText;
    };


    // TODO later - for clicks on links, where we can display our own modal dialogue
    //this.registerLinkClickedChecker = function (options) {
    //    var promptCheckingFunction = options.promptCheckingFunction;
    //    var userLeftCallbackFunction = options.userLeftCallbackFunction;
    //    var userStayedCallbackFunction = options.userStayedCallbackFunction;
    //    var dialogueUrl = options.dialogueUrl;
    //
    //    if(dialogueUrl typeof 'undefined') dialogueUrl = this.defaultDialogueUrl;
    //    // TODO process received data. Make sure the user truly leaves? (call the transition function for the client?)
    //};
    //
    //this.askForConfirmation = function () {
    //    var requester = this;
    //
    //    $.ajax({
    //        url: requester.getDiscardUnsavedChangesDialogueUrl,
    //        type: "get",
    //        success: function (modalHtml) {
    //            $(requester.modalsSectionId).append(modalHtml);
    //            var modal = $(modalHtml);
    //            modal.modal();
    //
    //            var leaveButton = modal.find("[data-button-role='discard']");
    //
    //            leaveButton.click(function (e) {
    //                    modal.modal('hide');
    //
    //                    requester.$primaryList.val(requester.latestPrimaryListVal).trigger("change");
    //                    requester.loadNewValues(loadValuesUrl);
    //
    //                    e.preventDefault();
    //                }
    //            );
    //        }
    //    });
    //};
}